module.exports = __webpack_public_path__ + "src/assets/models/petri/incubator_door.fbx";